/* eslint-disable */// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/*!
 * Glide.js v3.4.0
 * (c) 2013-2020 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */let defaults={/**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */startAt:0,/**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */perView:1,/**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */perMove:1,/**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */focusAt:0,/**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */gap:0,/**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */autoplay:!1,/**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */hoverpause:!0,/**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */keyboard:!0,/**
   * Type of the movement.
   *
   * @type {Boolean}
   */loop:!0,/**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only when not looping and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */bound:!1,/**
   * Slider will rewind to the first/last slide when it's at the start/end. Has an effect only when not looping.
   *
   * @type {Boolean}
   */rewind:!1,/**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `perView` - Moves slider by one slide per swipe
   * `perMove` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {"perView" | "perMove"}
   */perSwipe:"perMove",/**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */swipeThreshold:80,/**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */dragThreshold:120,/**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */touchAngle:45,/**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */touchRatio:.5,/**
   * Definest how many clones will be created in looped mode.
   *
   * @type {Number}
   */cloneRatio:1,/**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */animationDuration:400,/**
   * Easing function for the animation.
   *
   * @type {String}
   */animationTimingFunc:"cubic-bezier(.165, .840, .440, 1)",/**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */throttle:10,/**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */direction:"ltr",/**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */peek:0,/**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */breakpoints:{},/**
   * Collection of internally used HTML classes.
   *
   * @type {Object}
   */classes:{swipeable:"glide--swipeable",direction:{ltr:"glide--ltr",rtl:"glide--rtl"},dragging:"is-dragging",slide:{clone:"is-clone",active:"is-active"},arrow:{disabled:"is-disabled"},nav:{active:"is-active"}}};/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */function warn(msg){console.error("[Glide warn]: "+msg)}let _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&"function"==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj},classCallCheck=function(instance,Constructor){if(!(instance instanceof Constructor))throw TypeError("Cannot call a class as a function")},createClass=function(){function defineProperties(target,props){for(let i=0;i<props.length;i++){let descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,"value"in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_extends=Object.assign||function(target){for(let i=1;i<arguments.length;i++){let source=arguments[i];for(let key in source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key])}return target},get=function get(object,property,receiver){null===object&&(object=Function.prototype);let desc=Object.getOwnPropertyDescriptor(object,property);if(void 0===desc){let parent=Object.getPrototypeOf(object);if(null===parent)return;return get(parent,property,receiver)}if("value"in desc)return desc.value;{let getter=desc.get;if(void 0===getter)return;return getter.call(receiver)}},inherits=function(subClass,superClass){if("function"!=typeof superClass&&null!==superClass)throw TypeError("Super expression must either be null or a function, not "+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)},possibleConstructorReturn=function(self,call){if(!self)throw ReferenceError("this hasn't been initialised - super() hasn't been called");return call&&("object"==typeof call||"function"==typeof call)?call:self};/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */function toInt(value){return parseInt(value)}/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */function isString(value){return"string"==typeof value}/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */function isObject(value){let type=void 0===value?"undefined":_typeof(value);return"function"===type||"object"===type&&!!value;// eslint-disable-line no-mixed-operators
}/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */function isFunction(value){return"function"==typeof value}/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */function isArray(value){return value.constructor===Array}/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */function define(obj,prop,definition){Object.defineProperty(obj,prop,definition)}/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} target
 * @param  {Object} source
 * @return {Object}
 */function mergeDeep(target,source){let output=_extends({},target);return isObject(source)&&(isObject(target)||(target={}),Object.keys(source).forEach(function(key){var obj,value;isObject(source[key])&&key in target?output[key]=mergeDeep(target[key],source[key]):_extends(output,(obj={},value=source[key],key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj))})),output}let EventsBus=function(){/**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */function EventsBus(){let events=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};classCallCheck(this,EventsBus),this.events=events,this.hop=events.hasOwnProperty}return(/**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */createClass(EventsBus,[{key:"on",value:function(event,handler){if(isArray(event)){for(let i=0;i<event.length;i++)this.on(event[i],handler);return}this.hop.call(this.events,event)||(this.events[event]=[]);// Add the handler to queue
let index=this.events[event].push(handler)-1;// Provide handle back for removal of event
return{remove:function(){delete this.events[event][index]}}}},{key:"emit",value:function(event,context){if(isArray(event)){for(let i=0;i<event.length;i++)this.emit(event[i],context);return}this.hop.call(this.events,event)&&// Cycle through events queue, fire!
this.events[event].forEach(function(item){item(context||{})})}}]),EventsBus)}(),Glide=function(){/**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */function Glide(selector){let options=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};classCallCheck(this,Glide),this._c={},this._t=[],this._e=new EventsBus,this.disabled=!1,this.selector=selector,this.settings=mergeDeep(defaults,options),this.index=this.settings.startAt}return(/**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */createClass(Glide,[{key:"mount",value:function(){let extensions=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this._e.emit("mount.before"),isObject(extensions)?this._c=/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */function(glide,extensions,events){let components={};for(let name in extensions)isFunction(extensions[name])?components[name]=extensions[name](glide,components,events):warn("Extension must be a function");for(let _name in components)isFunction(components[_name].mount)&&components[_name].mount();return components}(this,extensions,this._e):warn("You need to provide a object on `mount()`"),this._e.emit("mount.after"),this}},{key:"mutate",value:function(){let transformers=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[];return isArray(transformers)?this._t=transformers:warn("You need to provide a array on `mutate()`"),this}},{key:"update",value:function(){let settings=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return this.settings=mergeDeep(this.settings,settings),settings.hasOwnProperty("startAt")&&(this.index=settings.startAt),this._e.emit("update"),this}},{key:"go",value:function(pattern){return this._c.Run.make(pattern),this}},{key:"move",value:function(distance){return this._c.Transition.disable(),this._c.Move.make(distance),this}},{key:"destroy",value:function(){return this._e.emit("destroy"),this}},{key:"play",value:function(){let interval=arguments.length>0&&void 0!==arguments[0]&&arguments[0];return interval&&(this.settings.autoplay=interval),this._e.emit("play"),this}},{key:"pause",value:function(){return this._e.emit("pause"),this}},{key:"disable",value:function(){return this.disabled=!0,this}},{key:"enable",value:function(){return this.disabled=!1,this}},{key:"on",value:function(event,handler){return this._e.on(event,handler),this}},{key:"settings",get:function(){return this._o},/**
       * Sets value of the core options.
       *
       * @param  {Object} o
       * @return {Void}
       */set:function(o){isObject(o)?this._o=o:warn("Options must be an `object` instance.")}},{key:"index",get:function(){return this._i},/**
       * Sets current index a slider.
       *
       * @return {Object}
       */set:function(i){this._i=toInt(i)}},{key:"disabled",get:function(){return this._d},/**
       * Sets value of the idle status.
       *
       * @return {Boolean}
       */set:function(status){this._d=!!status}}]),Glide)}();/**
 * Returns a current time.
 *
 * @return {Number}
 */function now(){return new Date().getTime()}/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */function throttle(func,wait,options){let timeout,context,args,result;let previous=0;options||(options={});let later=function(){previous=!1===options.leading?0:now(),timeout=null,result=func.apply(context,args),timeout||(context=args=null)},throttled=function(){let at=now();previous||!1!==options.leading||(previous=at);let remaining=wait-(at-previous);return context=this,args=arguments,remaining<=0||remaining>wait?(timeout&&(clearTimeout(timeout),timeout=null),previous=at,result=func.apply(context,args),timeout||(context=args=null)):timeout||!1===options.trailing||(timeout=setTimeout(later,remaining)),result};return throttled.cancel=function(){clearTimeout(timeout),previous=0,timeout=context=args=null},throttled}let MARGIN_TYPE={ltr:["marginLeft","marginRight"],rtl:["marginRight","marginLeft"]};/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */function siblings(node){if(node&&node.parentNode){let n=node.parentNode.firstChild,matched=[];for(;n;n=n.nextSibling)1===n.nodeType&&n!==node&&matched.push(n);return matched}return[]}/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */function exist(node){return!!node&&node instanceof window.HTMLElement}let TRACK_SELECTOR='[data-glide-el="track"]',EventsBinder=function(){/**
   * Construct a EventsBinder instance.
   */function EventsBinder(){let listeners=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};classCallCheck(this,EventsBinder),this.listeners=listeners}return(/**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */createClass(EventsBinder,[{key:"on",value:function(events,el,closure){let capture=arguments.length>3&&void 0!==arguments[3]&&arguments[3];isString(events)&&(events=[events]);for(let i=0;i<events.length;i++)this.listeners[events[i]]=closure,el.addEventListener(events[i],this.listeners[events[i]],capture)}},{key:"off",value:function(events,el){let capture=arguments.length>2&&void 0!==arguments[2]&&arguments[2];isString(events)&&(events=[events]);for(let i=0;i<events.length;i++)el.removeEventListener(events[i],this.listeners[events[i]],capture)}},{key:"destroy",value:function(){delete this.listeners}}]),EventsBinder)}(),VALID_DIRECTIONS=["ltr","rtl"],FLIPED_MOVEMENTS={">":"<","<":">","=":"="};/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */function Rtl(Glide,Components){/**
   * Negates the passed translate if glide is in RTL option.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){return Components.Direction.is("rtl")?-translate:translate}}/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */function Gap(Glide,Components){/**
   * Modifies passed translate value with number in the `gap` settings.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){let multiplier=Math.floor(translate/Components.Sizes.slideWidth);return translate+Components.Gaps.value*multiplier}}/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */function Grow(Glide,Components){/**
   * Adds to the passed translate width of the half of clones.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){return translate+Components.Clones.grow/2}}/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */function Peeking(Glide,Components){/**
   * Modifies passed translate value with a `peek` setting.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){if(Glide.settings.focusAt>=0){let peek=Components.Peek.value;return isObject(peek)?translate-peek.before:translate-peek}return translate}}/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */function Focusing(Glide,Components){/**
   * Modifies passed translate value with index in the `focusAt` setting.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){let gap=Components.Gaps.value,width=Components.Sizes.width,focusAt=Glide.settings.focusAt,slideWidth=Components.Sizes.slideWidth;return"center"===focusAt?translate-(width/2-slideWidth/2):translate-slideWidth*focusAt-gap*focusAt}}/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */let supportsPassive=!1;try{let opts=Object.defineProperty({},"passive",{get:function(){supportsPassive=!0}});window.addEventListener("testPassive",null,opts),window.removeEventListener("testPassive",null,opts)}catch(e){}let supportsPassive$1=supportsPassive,MOVE_EVENTS=["touchmove","mousemove"],END_EVENTS=["touchend","touchcancel","mouseup","mouseleave"],MOUSE_EVENTS=["mousedown","mousemove","mouseup","mouseleave"];function swipe(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,swipeSin=0,swipeStartX=0,swipeStartY=0,disabled=!1,capture=!!supportsPassive$1&&{passive:!0},Swipe={/**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */mount:function(){this.bindSwipeStart()},/**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */start:function(event){if(!disabled&&!Glide.disabled){this.disable();let swipe=this.touches(event);swipeSin=null,swipeStartX=toInt(swipe.pageX),swipeStartY=toInt(swipe.pageY),this.bindSwipeMove(),this.bindSwipeEnd(),Events.emit("swipe.start")}},/**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */move:function(event){if(!Glide.disabled){let _Glide$settings=Glide.settings,touchAngle=_Glide$settings.touchAngle,touchRatio=_Glide$settings.touchRatio,classes=_Glide$settings.classes,swipe=this.touches(event),subExSx=toInt(swipe.pageX)-swipeStartX,subEySy=toInt(swipe.pageY)-swipeStartY,powEX=Math.abs(subExSx<<2),powEY=Math.abs(subEySy<<2);if(!(180*(swipeSin=Math.asin(Math.sqrt(powEY)/Math.sqrt(powEX+powEY)))/Math.PI<touchAngle))return!1;event.stopPropagation(),Components.Move.make(subExSx*parseFloat(touchRatio)),Components.Html.root.classList.add(classes.dragging),Events.emit("swipe.move")}},/**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */end:function(event){if(!Glide.disabled){let settings=Glide.settings,swipe=this.touches(event),threshold=this.threshold(event),swipeDistance=swipe.pageX-swipeStartX,swipeDeg=180*swipeSin/Math.PI,steps=toInt(settings[settings.perSwipe]);this.enable(),swipeDistance>threshold&&swipeDeg<settings.touchAngle?Components.Run.make(""+Components.Direction.resolve("<")+steps):swipeDistance<-threshold&&swipeDeg<settings.touchAngle?Components.Run.make(""+Components.Direction.resolve(">")+steps):// While swipe don't reach distance apply previous transform.
Components.Move.make(),Components.Html.track.classList.remove(settings.classes.dragging),this.unbindSwipeMove(),this.unbindSwipeEnd(),Events.emit("swipe.end")}},/**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */bindSwipeStart:function(){let _this=this,settings=Glide.settings;settings.swipeThreshold&&Binder.on("touchstart",Components.Html.wrapper,function(event){_this.start(event)},capture),settings.dragThreshold&&Binder.on("mousedown",Components.Html.wrapper,function(event){_this.start(event)},capture)},/**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */unbindSwipeStart:function(){Binder.off("touchstart",Components.Html.wrapper,capture),Binder.off("mousedown",Components.Html.wrapper,capture)},/**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */bindSwipeMove:function(){let _this2=this;Binder.on(MOVE_EVENTS,Components.Html.wrapper,throttle(function(event){_this2.move(event)},Glide.settings.throttle),capture)},/**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */unbindSwipeMove:function(){Binder.off(MOVE_EVENTS,Components.Html.wrapper,capture)},/**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */bindSwipeEnd:function(){let _this3=this;Binder.on(END_EVENTS,Components.Html.wrapper,function(event){_this3.end(event)})},/**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */unbindSwipeEnd:function(){Binder.off(END_EVENTS,Components.Html.wrapper)},/**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */touches:function(event){return MOUSE_EVENTS.indexOf(event.type)>-1?event:event.touches[0]||event.changedTouches[0]},/**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */threshold:function(event){let settings=Glide.settings;return MOUSE_EVENTS.indexOf(event.type)>-1?settings.dragThreshold:settings.swipeThreshold},/**
     * Enables swipe event.
     *
     * @return {self}
     */enable:function(){return disabled=!1,Components.Transition.enable(),this},/**
     * Disables swipe event.
     *
     * @return {self}
     */disable:function(){return disabled=!0,Components.Transition.disable(),this}};return(/**
   * Add component class:
   * - after initial building
   */Events.on("build.after",function(){Components.Html.root.classList.add(Glide.settings.classes.swipeable)}),/**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners and classes
   */Events.on("destroy",function(){Swipe.unbindSwipeStart(),Swipe.unbindSwipeMove(),Swipe.unbindSwipeEnd(),Components.Html.root.classList.remove(Glide.settings.classes.swipeable),Binder.destroy()}),Swipe)}function images(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,Images={/**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */mount:function(){this.bind()},/**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */bind:function(){Binder.on("dragstart",Components.Html.wrapper,this.dragstart)},/**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */unbind:function(){Binder.off("dragstart",Components.Html.wrapper)},/**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */dragstart:function(event){event.preventDefault()}};return(/**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */Events.on("destroy",function(){Images.unbind(),Binder.destroy()}),Images)}function anchors(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,detached=!1,prevented=!1,Anchors={/**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */mount:function(){/**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */this._a=Components.Html.wrapper.querySelectorAll("a"),this.bind()},/**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */bind:function(){Binder.on("click",Components.Html.wrapper,this.click)},/**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */unbind:function(){Binder.off("click",Components.Html.wrapper)},/**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */click:function(event){prevented&&(event.stopPropagation(),event.preventDefault())},/**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */detach:function(){if(prevented=!0,!detached){for(let i=0;i<this.items.length;i++)this.items[i].draggable=!1,this.items[i].setAttribute("data-href",this.items[i].getAttribute("href")),this.items[i].removeAttribute("href");detached=!0}return this},/**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */attach:function(){if(prevented=!1,detached){for(let i=0;i<this.items.length;i++)this.items[i].draggable=!0,this.items[i].setAttribute("href",this.items[i].getAttribute("data-href"));detached=!1}return this}};return define(Anchors,"items",{/**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */get:function(){return Anchors._a}}),/**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */Events.on("swipe.move",function(){Anchors.detach()}),/**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */Events.on("swipe.end",function(){Components.Transition.after(function(){Anchors.attach()})}),/**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */Events.on("destroy",function(){Anchors.attach(),Anchors.unbind(),Binder.destroy()}),Anchors}let CONTROLS_SELECTOR='[data-glide-el^="controls"]',PREVIOUS_CONTROLS_SELECTOR=CONTROLS_SELECTOR+' [data-glide-dir*="<"]',NEXT_CONTROLS_SELECTOR=CONTROLS_SELECTOR+' [data-glide-dir*=">"]';function controls(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,capture=!!supportsPassive$1&&{passive:!0};var Controls={/**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */mount:function(){/**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */this._n=Components.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'),/**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */this._c=Components.Html.root.querySelectorAll(CONTROLS_SELECTOR),/**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */this._arrowControls={previous:Components.Html.root.querySelectorAll(PREVIOUS_CONTROLS_SELECTOR),next:Components.Html.root.querySelectorAll(NEXT_CONTROLS_SELECTOR)},this.addBindings()},/**
     * Sets active class to current slide.
     *
     * @return {Void}
     */setActive:function(){for(let i=0;i<this._n.length;i++)this.addClass(this._n[i].children)},/**
     * Removes active class to current slide.
     *
     * @return {Void}
     */removeActive:function(){for(let i=0;i<this._n.length;i++)this.removeClass(this._n[i].children)},/**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */addClass:function(controls){let settings=Glide.settings,item=controls[Glide.index];item&&item&&(item.classList.add(settings.classes.nav.active),siblings(item).forEach(function(sibling){sibling.classList.remove(settings.classes.nav.active)}))},/**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */removeClass:function(controls){let item=controls[Glide.index];item&&item.classList.remove(Glide.settings.classes.nav.active)},/**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */setArrowState:function(){if(Glide.settings.rewind)return;let next=Controls._arrowControls.next,previous=Controls._arrowControls.previous;this.resetArrowState(next,previous),Glide.settings.loop||(0===Glide.index&&this.disableArrow(previous),Glide.index===Components.Run.length&&this.disableArrow(next))},/**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */resetArrowState:function(){let settings=Glide.settings;for(var _len=arguments.length,lists=Array(_len),_key=0;_key<_len;_key++)lists[_key]=arguments[_key];lists.forEach(function(list){list.forEach(function(element){element.classList.remove(settings.classes.arrow.disabled)})})},/**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */disableArrow:function(){let settings=Glide.settings;for(var _len2=arguments.length,lists=Array(_len2),_key2=0;_key2<_len2;_key2++)lists[_key2]=arguments[_key2];lists.forEach(function(list){list.forEach(function(element){element.classList.add(settings.classes.arrow.disabled)})})},/**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */addBindings:function(){for(let i=0;i<this._c.length;i++)this.bind(this._c[i].children)},/**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */removeBindings:function(){for(let i=0;i<this._c.length;i++)this.unbind(this._c[i].children)},/**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */bind:function(elements){for(let i=0;i<elements.length;i++)Binder.on("click",elements[i],this.click),Binder.on("touchstart",elements[i],this.click,capture)},/**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */unbind:function(elements){for(let i=0;i<elements.length;i++)Binder.off(["click","touchstart"],elements[i])},/**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */click:function(event){supportsPassive$1||"touchstart"!==event.type||event.preventDefault();let direction=event.currentTarget.getAttribute("data-glide-dir");Components.Run.make(Components.Direction.resolve(direction))}};return define(Controls,"items",{/**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */get:function(){return Controls._c}}),/**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */Events.on(["mount.after","move.after"],function(){Controls.setActive()}),/**
   * Add or remove disabled class of arrow elements
   */Events.on(["mount.after","run"],function(){Controls.setArrowState()}),/**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */Events.on("destroy",function(){Controls.removeBindings(),Controls.removeActive(),Binder.destroy()}),Controls}function keyboard(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,Keyboard={/**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */mount:function(){Glide.settings.keyboard&&this.bind()},/**
     * Adds keyboard press events.
     *
     * @return {Void}
     */bind:function(){Binder.on("keyup",document,this.press)},/**
     * Removes keyboard press events.
     *
     * @return {Void}
     */unbind:function(){Binder.off("keyup",document)},/**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */press:function(event){let perSwipe=Glide.settings.perSwipe;perSwipe="number"==typeof perSwipe?perSwipe:"",39===event.keyCode&&Components.Run.make(Components.Direction.resolve(perSwipe+">")),37===event.keyCode&&Components.Run.make(Components.Direction.resolve(perSwipe+"<"))}};return(/**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */Events.on(["destroy","update"],function(){Keyboard.unbind()}),/**
   * Remount component
   * - on updating to reflect potential changes in settings
   */Events.on("update",function(){Keyboard.mount()}),/**
   * Destroy binder:
   * - on destroying to remove listeners
   */Events.on("destroy",function(){Binder.destroy()}),Keyboard)}function autoplay(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,Autoplay={/**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */mount:function(){this.start(),Glide.settings.hoverpause&&this.bind()},/**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */start:function(){let _this=this;Glide.settings.autoplay&&void 0===this._i&&(this._i=setInterval(function(){_this.stop(),Components.Run.make(">"),_this.start(),Events.emit("autoplay")},this.time))},/**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */stop:function(){this._i=clearInterval(this._i)},/**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */bind:function(){let _this2=this;Binder.on("mouseenter",Components.Html.root,function(){_this2.stop(),Events.emit("autoplay.enter")}),Binder.on("mouseleave",Components.Html.root,function(){_this2.start(),Events.emit("autoplay.leave")})},/**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */unbind:function(){Binder.off(["mouseover","mouseout"],Components.Html.root)}};return define(Autoplay,"time",{/**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */get:function(){let autoplay=Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");return autoplay?toInt(autoplay):toInt(Glide.settings.autoplay)}}),/**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */Events.on(["destroy","update"],function(){Autoplay.unbind()}),/**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */Events.on(["run.before","pause","destroy","swipe.start","update"],function(){Autoplay.stop()}),/**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */Events.on(["run.after","play","swipe.end"],function(){Autoplay.start()}),/**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */Events.on("update",function(){Autoplay.mount()}),/**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */Events.on("destroy",function(){Binder.destroy()}),Autoplay}/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */function sortBreakpoints(points){return isObject(points)?Object.keys(points).sort().reduce(function(r,k){return r[k]=points[k],r[k],r},{}):(warn("Breakpoints option must be an object"),{})}function breakpoints(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,settings=Glide.settings,points=sortBreakpoints(settings.breakpoints),defaults=_extends({},settings),Breakpoints={/**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */match:function(points){if(void 0!==window.matchMedia){for(let point in points)if(points.hasOwnProperty(point)&&window.matchMedia("(max-width: "+point+"px)").matches)return points[point]}return defaults}};return(/**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */_extends(settings,Breakpoints.match(points)),/**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */Binder.on("resize",window,throttle(function(){Glide.settings=mergeDeep(settings,Breakpoints.match(points))},Glide.settings.throttle)),/**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */Events.on("update",function(){points=sortBreakpoints(points),defaults=_extends({},settings)}),/**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */Events.on("destroy",function(){Binder.off("resize",window)}),Breakpoints)}let COMPONENTS={Html:function(Glide,Components,Events){let Html={/**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */mount:function(){this.root=Glide.selector,this.root.classList.add("glide--mounted"),this.track=this.root.querySelector(TRACK_SELECTOR),this.slides=[];let realSlideIdx=0;for(let i=0;i<this.wrapper.children.length;i++){let slide=this.wrapper.children[i],isClone=slide.classList.contains(Glide.settings.classes.slide.clone);!isClone&&(slide.setAttribute("data-glide-idx",realSlideIdx),this.slides.push(slide),realSlideIdx++)}},destroy:function(){this.root.classList.remove("glide--mounted")}};return define(Html,"root",{/**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */get:function(){return Html._r},/**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */set:function(r){isString(r)&&(r=document.querySelector(r)),exist(r)?Html._r=r:warn("Root element must be a existing Html node")}}),define(Html,"track",{/**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */get:function(){return Html._t},/**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */set:function(t){exist(t)?Html._t=t:warn("Could not find track element. Please use "+TRACK_SELECTOR+" attribute.")}}),define(Html,"wrapper",{/**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */get:function(){return Html.track.children[0]}}),Events.on("destroy",function(){return Html.destroy()}),Html},Translate:function(Glide,Components,Events){let Translate={/**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */set:function(value){let transform=/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */(function(Glide,Components,Events){/**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */let TRANSFORMERS=[Gap,Grow,Peeking,Focusing].concat(Glide._t,[Rtl]);/**
   * Piplines translate value with registered transformers.
   *
   * @param  {Number} translate
   * @return {Number}
   */return function(translate){for(let i=0;i<TRANSFORMERS.length;i++){let transformer=TRANSFORMERS[i];isFunction(transformer)&&isFunction(transformer())?translate=transformer(Glide,Components,Events)(translate):warn("Transformer should be a function that returns the function")}return translate}})(Glide,Components,Events)(value);Components.Html.wrapper.style.transform="translate3d("+-1*transform+"px, 0px, 0px)"},/**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */remove:function(){Components.Html.wrapper.style.transform=""}};return(/**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */Events.on("move",function(context){let length=Components.Sizes.length,width=Components.Sizes.slideWidth;return Glide.settings.loop&&Components.Run.isOffset("<")?(Components.Transition.after(function(){Events.emit("translate.jump"),Translate.set(width*Glide.index)}),Translate.set(-(width*(length-Glide.index)))):Glide.settings.loop&&Components.Run.isOffset(">")?(Components.Transition.after(function(){Events.emit("translate.jump"),Translate.set(width*Glide.index)}),Translate.set(width*(length+Glide.index))):Translate.set(context.movement)}),/**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */Events.on("destroy",function(){Translate.remove()}),Translate)},Transition:function(Glide,Components,Events){/**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */let disabled=!1,Transition={/**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */compose:function(property){let settings=Glide.settings;return disabled?property+" 0ms "+settings.animationTimingFunc:property+" "+this.duration+"ms "+settings.animationTimingFunc},/**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */set:function(){let property=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"transform";Components.Html.wrapper.style.transition=this.compose(property)},/**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */remove:function(){Components.Html.wrapper.style.transition=""},/**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */after:function(callback){setTimeout(function(){callback()},this.duration)},/**
     * Enable transition.
     *
     * @return {Void}
     */enable:function(){disabled=!1,this.set()},/**
     * Disable transition.
     *
     * @return {Void}
     */disable:function(){disabled=!0,this.set()}};return define(Transition,"duration",{/**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */get:function(){let settings=Glide.settings;return!settings.loop&&Components.Run.offset?settings.rewindDuration:settings.animationDuration}}),/**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */Events.on("move",function(){Transition.set()}),/**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimentions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */Events.on(["build.before","resize","translate.jump"],function(){Transition.disable()}),/**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */Events.on("run",function(){Transition.enable()}),/**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */Events.on("destroy",function(){Transition.remove()}),Transition},Direction:function(Glide,Components,Events){let Direction={/**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */mount:function(){this.value=Glide.settings.direction},/**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */resolve:function(pattern){let token=pattern.slice(0,1);return this.is("rtl")?pattern.split(token).join(FLIPED_MOVEMENTS[token]):pattern},/**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */is:function(direction){return this.value===direction},/**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */addClass:function(){Components.Html.root.classList.add(Glide.settings.classes.direction[this.value])},/**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */removeClass:function(){Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value])}};return define(Direction,"value",{/**
     * Gets value of the direction.
     *
     * @returns {Number}
     */get:function(){return Direction._v},/**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */set:function(value){VALID_DIRECTIONS.indexOf(value)>-1?Direction._v=value:warn("Direction value must be `ltr` or `rtl`")}}),/**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */Events.on(["destroy","update"],function(){Direction.removeClass()}),/**
   * Remount component:
   * - on update to reflect changes in direction value
   */Events.on("update",function(){Direction.mount()}),/**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */Events.on(["build.before","update"],function(){Direction.addClass()}),Direction},Peek:function(Glide,Components,Events){let Peek={/**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */mount:function(){this.value=Glide.settings.peek}};return define(Peek,"value",{/**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */get:function(){return Peek._v},/**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */set:function(value){isObject(value)?(value.before=toInt(value.before),value.after=toInt(value.after)):value=toInt(value),Peek._v=value}}),define(Peek,"reductor",{/**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */get:function(){let value=Peek.value,perView=Glide.settings.perView;return isObject(value)?value.before/perView+value.after/perView:2*value/perView}}),/**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */Events.on(["resize","update"],function(){Peek.mount()}),Peek},Sizes:function(Glide,Components,Events){let Sizes={/**
     * Setups dimentions of slides.
     *
     * @return {Void}
     */setupSlides:function(){let width=this.slideWidth+"px",slides=Components.Html.slides;for(let i=0;i<slides.length;i++)slides[i].style.width=width},/**
     * Setups dimentions of slides wrapper.
     *
     * @return {Void}
     */setupWrapper:function(){Components.Html.wrapper.style.width=this.wrapperSize+"px"},/**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */remove:function(){let slides=Components.Html.slides;for(let i=0;i<slides.length;i++)slides[i].style.width="";Components.Html.wrapper.style.width=""}};return define(Sizes,"length",{/**
     * Gets count number of the slides.
     *
     * @return {Number}
     */get:function(){return Components.Html.slides.length}}),define(Sizes,"width",{/**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */get:function(){let _Components$Html=Components.Html,root=_Components$Html.root,track=_Components$Html.track,element=Glide.settings.sizeByTrack?track:root;return element.getBoundingClientRect().width}}),define(Sizes,"wrapperSize",{/**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */get:function(){return Sizes.slideWidth*Sizes.length+Components.Gaps.grow+Components.Clones.grow}}),define(Sizes,"slideWidth",{/**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */get:function(){return Sizes.width/Glide.settings.perView-Components.Peek.reductor-Components.Gaps.reductor}}),/**
   * Apply calculated glide's dimensions:
   * - before building, so other dimentions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */Events.on(["build.before","resize","update"],function(){Sizes.setupSlides(),Sizes.setupWrapper()}),/**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */Events.on("destroy",function(){Sizes.remove()}),Sizes},Gaps:function(Glide,Components,Events){let Gaps={/**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */apply:function(slides){for(let i=0,len=slides.length;i<len;i++){let style=slides[i].style,direction=Components.Direction.value;0!==i?style[MARGIN_TYPE[direction][0]]=this.value/2+"px":style[MARGIN_TYPE[direction][0]]="",i!==slides.length-1?style[MARGIN_TYPE[direction][1]]=this.value/2+"px":style[MARGIN_TYPE[direction][1]]=""}},/**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
     */remove:function(slides){for(let i=0,len=slides.length;i<len;i++){let style=slides[i].style;style.marginLeft="",style.marginRight=""}}};return define(Gaps,"value",{/**
     * Gets value of the gap.
     *
     * @returns {Number}
     */get:function(){return toInt(Glide.settings.gap)}}),define(Gaps,"grow",{/**
     * Gets additional dimentions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */get:function(){return Gaps.value*Components.Sizes.length}}),define(Gaps,"reductor",{/**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */get:function(){let perView=Glide.settings.perView;return Gaps.value*(perView-1)/perView}}),/**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */Events.on(["build.after","update"],throttle(function(){Gaps.apply(Components.Html.wrapper.children)},30)),/**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */Events.on("destroy",function(){Gaps.remove(Components.Html.wrapper.children)}),Gaps},Move:function(Glide,Components,Events){let Move={/**
     * Constructs move component.
     *
     * @returns {Void}
     */mount:function(){this._o=0},/**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */make:function(){let _this=this,offset=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.offset=offset,Events.emit("move",{movement:this.value}),Components.Transition.after(function(){Events.emit("move.after",{movement:_this.value})})}};return define(Move,"offset",{/**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */get:function(){return Move._o},/**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */set:function(value){Move._o=void 0===value?0:toInt(value)}}),define(Move,"translate",{/**
     * Gets a raw movement value.
     *
     * @return {Number}
     */get:function(){return Components.Sizes.slideWidth*Glide.index}}),define(Move,"value",{/**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */get:function(){let offset=this.offset,translate=this.translate;return Components.Direction.is("rtl")?translate+offset:translate-offset}}),/**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */Events.on(["build.before","run"],function(){Move.make()}),Move},Clones:function(Glide,Components,Events){let Clones={/**
     * Create pattern map and collect slides to be cloned.
     */mount:function(){this.items=[],Glide.settings.loop&&(this.items=this.collect(),Events.emit("clones.after"))},/**
     * Collect clones with pattern.
     *
     * @return {[]}
     */collect:function(){let items=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],slides=Components.Html.slides,_Glide$settings=Glide.settings,perView=_Glide$settings.perView,cloneRatio=_Glide$settings.cloneRatio,classes=_Glide$settings.classes;if(0!==slides.length){let peekIncrementer=+!!Glide.settings.peek,cloneCount=perView+peekIncrementer+Math.round(perView/2),append=slides.slice(0,cloneCount).reverse(),prepend=slides.slice(-1*cloneCount);for(let r=0;r<Math.max(cloneRatio,Math.floor(perView/slides.length));r++){for(let i=0;i<append.length;i++){let clone=append[i].cloneNode(!0);clone.classList.add(classes.slide.clone),items.push(clone)}for(let _i=0;_i<prepend.length;_i++){let _clone=prepend[_i].cloneNode(!0);_clone.classList.add(classes.slide.clone),items.unshift(_clone)}}}return items},/**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */append:function(){let items=this.items,_Components$Html=Components.Html,wrapper=_Components$Html.wrapper,slides=_Components$Html.slides,half=Math.floor(items.length/2),prepend=items.slice(0,half).reverse(),append=items.slice(-1*half).reverse(),width=Components.Sizes.slideWidth+"px";for(let i=0;i<append.length;i++)wrapper.appendChild(append[i]);for(let _i2=0;_i2<prepend.length;_i2++)wrapper.insertBefore(prepend[_i2],slides[0]);for(let _i3=0;_i3<items.length;_i3++)items[_i3].style.width=width},/**
     * Remove all cloned slides.
     *
     * @return {Void}
     */remove:function(){let items=this.items;for(let i=0;i<items.length;i++)Components.Html.wrapper.removeChild(items[i])}};return define(Clones,"grow",{/**
     * Gets additional dimentions value caused by clones.
     *
     * @return {Number}
     */get:function(){return(Components.Sizes.slideWidth+Components.Gaps.value)*Clones.items.length}}),/**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */Events.on("update",function(){Clones.remove(),Clones.mount(),Clones.append()}),/**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */Events.on("build.before",function(){Glide.settings.loop&&Clones.append()}),/**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */Events.on("destroy",function(){Clones.remove()}),Clones},Resize:function(Glide,Components,Events){/**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */let Binder=new EventsBinder,Resize={/**
     * Initializes window bindings.
     */mount:function(){this.bind()},/**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */bind:function(){Binder.on("resize",window,throttle(function(){Events.emit("resize")},Glide.settings.throttle))},/**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */unbind:function(){Binder.off("resize",window)}};return(/**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */Events.on("destroy",function(){Resize.unbind(),Binder.destroy()}),Resize)},Build:function(Glide,Components,Events){let Build={/**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */mount:function(){Events.emit("build.before"),this.activeClass(),Events.emit("build.after")},/**
     * Sets active class to current slide.
     *
     * @return {Void}
     */activeClass:function(){let classes=Glide.settings.classes,slide=Components.Html.slides[Glide.index];slide&&(slide.classList.add(classes.slide.active),siblings(slide).forEach(function(sibling){sibling.classList.remove(classes.slide.active)}))},/**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */removeClasses:function(){let slide=Glide.settings.classes.slide;Components.Html.slides.forEach(function(sibling){sibling.classList.remove(slide.active)})}};return(/**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */Events.on(["destroy","update"],function(){Build.removeClasses()}),/**
   * Remount component:
   * - on resizing of the window to calculate new dimentions
   * - on updating settings via API
   */Events.on(["resize","update"],function(){Build.mount()}),/**
   * Swap active class of current slide:
   * - after each move to the new index
   */Events.on("move.after",function(){Build.activeClass()}),Build)},Run:function(Glide,Components,Events){let Run={/**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */mount:function(){this._o=!1},/**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */make:function(move){let _this=this;Glide.disabled||(Glide.disable(),this.move=move,Events.emit("run.before",this.move),this.calculate(),Events.emit("run",this.move),Components.Transition.after(function(){_this.isStart()&&Events.emit("run.start",_this.move),_this.isEnd()&&Events.emit("run.end",_this.move),(_this.isOffset("<")||_this.isOffset(">"))&&(_this._o=!1,Events.emit("run.offset",_this.move)),Events.emit("run.after",_this.move),Glide.enable()}))},/**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */calculate:function(){let move=this.move,length=this.length,steps=move.steps,direction=move.direction,_Glide$settings=Glide.settings,loop=_Glide$settings.loop,perMove=_Glide$settings.perMove,distance="|"===steps?perMove:steps||1;// While direction is `=` we want jump to
// a specified index described in steps.
if("="===direction){Glide.settings.bound&&steps>length?Glide.index=length:Glide.index=steps;return}// When pattern is equal to `>>` we want
// fast forward to the last slide.
if(">"===direction&&">"===steps){Glide.index=length;return}// When pattern is equal to `<<` we want
// fast forward to the first slide.
if("<"===direction&&"<"===steps){Glide.index=0;return}if(">"===direction){let index=/**
   * Returns index value to move forward/to the right
   *
   * @param distance
   * @returns {Number}
   */function(distance){let index=Glide.index;return Glide.settings.loop?index+distance:index+(distance-index%distance)}(distance);index>length&&loop&&(this._o=!0),Glide.index=/**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param distance
   * @returns {Number}
   */function(index,distance){let length=Run.length;return index<=length?index:Glide.settings.loop?index-(length+1):Glide.settings.rewind?// bound does funny things with the length, therefor we have to be certain
// that we are on the last possible index value given by bound
Run.isBound()&&!Run.isEnd()?length:0:Run.isBound()?length:Math.floor(length/distance)*distance}(index,distance);return}if("<"===direction){let _index=/**
   * Calculates index value to move backward/to the left
   *
   * @param distance
   * @returns {Number}
   */function(distance){let index=Glide.index;return Glide.settings.loop?index-distance:(Math.ceil(index/distance)-1)*distance}(distance);_index<0&&loop&&(this._o=!0),Glide.index=/**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param distance
   * @returns {*}
   */function(index,distance){let length=Run.length;return index>=0?index:Glide.settings.loop?index+(length+1):Glide.settings.rewind?// bound does funny things with the length, therefor we have to be certain
// that we are on first possible index value before we to rewind to the length given by bound
Run.isBound()&&Run.isStart()?length:Math.floor(length/distance)*distance:0}(_index,distance);return}warn("Invalid direction pattern ["+direction+steps+"] has been used")},/**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */isStart:function(){return Glide.index<=0},/**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */isEnd:function(){return Glide.index>=this.length},/**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */isOffset:function(direction){return this._o&&this.move.direction===direction},/**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */isBound:function(){return!Glide.settings.loop&&"center"!==Glide.settings.focusAt&&Glide.settings.bound}};return define(Run,"move",{/**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */get:function(){return this._m},/**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */set:function(value){let step=value.substr(1);this._m={direction:value.substr(0,1),steps:step?toInt(step)?toInt(step):step:0}}}),define(Run,"length",{/**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */get:function(){let settings=Glide.settings,length=Components.Html.slides.length;return(// If the `bound` option is active, a maximum running distance should be
// reduced by `perView` and `focusAt` settings. Running distance
// should end before creating an empty space after instance.
this.isBound()?length-1-(toInt(settings.perView)-1)+toInt(settings.focusAt):length-1)}}),define(Run,"offset",{/**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */get:function(){return this._o}}),Run}},Glide$1=function(_Core){function Glide$$1(){return classCallCheck(this,Glide$$1),possibleConstructorReturn(this,(Glide$$1.__proto__||Object.getPrototypeOf(Glide$$1)).apply(this,arguments))}return inherits(Glide$$1,_Core),createClass(Glide$$1,[{key:"mount",value:function(){let extensions=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return get(Glide$$1.prototype.__proto__||Object.getPrototypeOf(Glide$$1.prototype),"mount",this).call(this,_extends({},COMPONENTS,extensions))}}]),Glide$$1}(Glide);export default Glide$1;export{swipe as Swipe,images as Images,anchors as Anchors,controls as Controls,keyboard as Keyboard,autoplay as Autoplay,breakpoints as Breakpoints,throttle};